import React from 'react'
import bg1 from '../../assets/images/bg1.svg'

const ContactBanner = () => {
    return (
        <div className='contact-banner'>
            <div><img src={bg1} alt='' /></div>
            <div className='content'>
                <div><h1>LET'S TALK ABOUT YOU, YOUR COMPANY, YOUR PROJECTS, AND YOUR GOALS.</h1></div>
            </div>
        </div>
    )
}

export default ContactBanner
